import { MouseEventHandler } from "react"
import styles from "./DefaultButton.module.css"

interface defaultButtonProps {
    title: string
    onClick?: MouseEventHandler<HTMLButtonElement> | undefined
    form?: string | undefined
    disabled?: boolean | undefined
}

export default function DefaultButton({title, onClick, form, disabled}: defaultButtonProps) {
    return(
        <button onClick={onClick} form={form} type="submit" disabled={disabled} className={styles.btn}>{title}</button>
    )
}